'use client';

import * as React from 'react';
import { Button } from '@/components/ui/button';
import { ReactNode, useState } from 'react';
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from '@/components/ui/popover';

type MenuProps = {
    items: { label: string; action: () => void; disabled?: boolean }[];
    children: ReactNode;
    onOpenMenu?: () => void;
};

export const Menu = ({ items, children, onOpenMenu }: MenuProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = (action: () => void) => {
        action();
        setIsOpen(false);
    };

    const handleOpenChange = (open: boolean) => {
        if (open) {
            onOpenMenu?.();
        }
        setIsOpen(open);
    };

    return (
        <Popover open={isOpen} onOpenChange={handleOpenChange}>
            <PopoverTrigger asChild>
                <Button
                    variant="ghost"
                    className="flex items-center gap-2"
                    active={isOpen}
                >
                    {children}
                </Button>
            </PopoverTrigger>
            <PopoverContent align="end" className="min-w-32 p-1">
                <ul>
                    {items.map((item, i) => (
                        <li key={i} className="w-full">
                            <Button
                                variant="ghost"
                                size="sm"
                                className="text-left justify-start w-full p-2 text-gray-50"
                                disabled={item.disabled}
                                onClick={() => handleClick(item.action)}
                            >
                                {item.label}
                            </Button>
                        </li>
                    ))}
                </ul>
            </PopoverContent>
        </Popover>
    );
};
